export default "__VITE_ASSET__b856951f__"